import gql from 'graphql-tag'

export const NOTIFICATION_GENERAL_LIST = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawAlerts {
        data {
          createdOn
          vehicleId
          vehicle {
            licensePlate
            id
            vehicleType {
              type
              model
              category
              icon
            }
            device {
              imei
              phoneNo
              deviceCode
            }
            sensor {
              sensorCode
            }
            imei
          }
          alertCode
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          driverId
          driver {
            fullname
            userId
          }
          alertFlag
          alertData
          formattedAlertData
          latitude
          longitude
          alertTrigger
          threshold
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const NOTIFICATION_LIST_CODES = gql`
  query AlertCodes($filter: GetAlertCodesInput) {
    alertCodes(filter: $filter) {
      isSuccessful
      message
      alertCodes {
        alertCode
        descriptionEng
        descriptionIdn
        alertCategories {
          alertCategoryId
          categoryEng
          categoryIdn
        }
      }
    }
  }
`

export const CREATE_NOTIFICATION = gql`
  mutation CreateNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      isSuccessful
      message
      notification {
        vehicleId
        vgroupId
        ugroupId
        userId
        alertCode
        byEmail
        byPush
        sound
      }
    }
  }
`

export const GET_NOTIFICATIONS = gql`
  query Notifications($filter: GetNotificationInput) {
    notifications(filter: $filter) {
      isSuccessful
      message
      notifications {
        vehicleId
        vgroupId
        ugroupId
        userId
        alertCode
        byEmail
        byPush
        sound
      }
    }
  }
`

export const GET_ALERT_CENTER = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      isSuccessful
      message
      status
      rawAlerts {
        data {
          rawAlertId
          alertCode
          alert {
            descriptionEng
            descriptionIdn
            iconUrl
          }
          driver {
            fullname
          }
          createdOn
          alertTrigger
          alertFlag
          alertData
          formattedAlertData
          vehicleId
          vehicle {
            licensePlate
            imei
            device {
              phoneNo
              deviceCode
            }
          }
          longitude
          latitude
          isImportant
          isUrgent
          isRead
          isResolved
          isFalseAlert
          lastUserFeedback {
            feedback
            createdOn
            user {
              fullname
            }
          }
          userLogs {
            typeField
            data
            createdOn
            user {
              fullname
            }
            userId
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`